import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { AvatarUploaderModalComponent } from "../avatar-uploader-modal/avatar-uploader-modal.component";

@Component({
  selector: "app-avatar",
  templateUrl: "./avatar.component.html",
  styleUrls: ["./avatar.component.scss"],
  standalone: false,
})
export class AvatarComponent implements OnInit {
  @Input() avatarUrl: string;
  @Input() avatarUploadUrl: string;
  @Input() localAvatar: boolean;
  @Input() size = 80;
  @Input() showChangeButton = true;
  @Input() employeeId: string;

  @Output() avatarChanged = new EventEmitter<void>();

  constructor(private dialog: MatDialog) {}

  ngOnInit() {}

  openAvatarUploader(): void {
    const dialogRef = this.dialog.open(AvatarUploaderModalComponent, {
      width: "640px",
      maxWidth: "90vw",
      maxHeight: "90vh",
      autoFocus: "dialog",
      panelClass: "app-dialog-panel",
      data: {
        avatarUploadUrl: this.avatarUploadUrl,
        thumbnailPhotoUrl: this.avatarUrl,
        localAvatar: this.localAvatar,
        employeeId: this.employeeId,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.avatarChanged.emit();
      }
    });
  }

  get avatarStyle(): Record<string, string> {
    return {
      width: `${this.size}px`,
      height: `${this.size}px`,
    };
  }

  get buttonStyle(): Record<string, string> {
    const buttonSize = Math.max(18, this.size * 0.225);
    return {
      width: `${buttonSize}px`,
      height: `${buttonSize}px`,
    };
  }
}
